<template>
	<section>
		<button v-if="adminDtls" type="button" :disabled="removeBulkLoading || removeBulk.length === 0" class="btn btn-outline-primary btn-round btn-sm pull-right" @click="removeBulkRedirects">
			<div class="loader small_loader" v-if="removeBulkLoading"></div>
			<span v-else>
				<i class="fa fa-plus mr-2"></i> Bulk Remove
			</span>
		</button>
		<div class="table-responsive">
			<table class="table text-center redirect-table">
				<thead class="text-primary">
				<tr>
					<th v-if="adminDtls" style="width: 8%;padding-left: 20px;vertical-align: baseline;">
						<div class="custom-control custom-checkbox p mr-sm-2">
							<input type="checkbox" class="custom-control-input" :disabled="removeBulkLoading" v-model="selectAllForRemoveBulk" @click="handleSelectAllForRemoveBulk" id="select_all_redirect"/>
							<label class="custom-control-label pt-1" for="select_all_redirect"></label>
						</div>
					</th>
					<th>Domain</th>
					<th>Redirect from</th>
					<th>Redirect to</th>
					<th>Status code</th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="redirect in redirects" :key="redirect.uuid" v-if="redirect.uuid" class="text-center">
					<td v-if="adminDtls" class="text-center">
						<div @click="selectAllForRemoveBulk = false" class="custom-control custom-checkbox ml-2 d-flex justify-content-center">
							<input type="checkbox" :id="'redirect_' + redirect.uuid" name="remove_bulk" :disabled="removeBulkLoading" v-model="removeBulk" :value="redirect.uuid" class="custom-control-input"/>
							<label class="custom-control-label" :for="'redirect_' + redirect.uuid"></label>
						</div>
					</td>
					<th>
						<select v-if="redirect.uuid === editItem.uuid" id="domain" class="form-control" :disabled="action">
							<option :value="domain" selected>{{domain}}</option>
						</select>
						<span v-else>{{domain}}</span>
					</th>
					<th>
						<input v-if="redirect.uuid === editItem.uuid" type="text" id="from" class="form-control" placeholder="/old/?$" v-model="editItem.from"   :disabled="action"/>
						<span v-else>{{redirect.from}}</span>
					</th>
					<th>
						<div v-if="redirect.uuid === editItem.uuid">
							<select class="form-control pull-left item-type p-0" id="type" v-model="editItem.type" :disabled="action">
								<option value="http://">http://</option>
								<option value="https://">https://</option>
							</select>
							<input type="text" id="to" class="form-control pull-right item-to" placeholder="https://domain.com/newurl" v-model="editItem.to" :disabled="action"/>
						</div>
						<span v-else>{{redirect.type}}{{redirect.to}}</span>
					</th>
					<th>
						<select v-if="redirect.uuid === editItem.uuid" class="form-control" id="code"
								v-model="editItem.code" :disabled="action">
							<option value="301">301</option>
							<option value="302">302</option>
						</select>
						<span v-else>{{redirect.code}}</span>
					</th>
					<th>
						<div v-if="redirect.uuid === editItem.uuid">
							<button type="button" class="btn btn-outline-danger btn-round pull-right btn-sm mt-1 ml-3"
									:disabled="action"
									@click="cancel">
								<i class="fa fa-ban"></i>
							</button>
							<button type="button"
									:disabled="action"
									class="btn btn-outline-primary btn-round pull-right btn-sm mt-1" @click="update">
								<div class="loader small_loader"
									 v-if="redirect.uuid === editItem.uuid && action === 'update'"></div>
								<i v-else class="fa fa-floppy-o"></i>
							</button>
						</div>
						<div v-else>
							<button type="button" class="btn btn-outline-danger btn-round pull-right btn-sm mt-1 ml-3"
									:disabled="action"
									@click="remove(redirect)">
								<div class="loader small_loader"
									 v-if="redirect.uuid === removeItem.uuid && action === 'remove'"></div>
								<i v-else class="fa fa-times"></i>
							</button>
							<button type="button"
									:disabled="action"
									class="btn btn-outline-primary btn-round pull-right btn-sm mt-1"
									@click="edit(redirect)">
								<i class="fa fa-pencil"></i>
							</button>
						</div>
					</th>
				</tr>
				</tbody>
			</table>
		</div>
	</section>
</template>

<script>
	import swal from "sweetalert2";
	import {db} from "@/firebase/init";
	import validateMethods from "../../../mixins/validateMethods";
	export default {
		name: "RedirectItems",
		mixins:[validateMethods],
		props: [
			"redirects",
			"domain",
			"itemChanged"
		],
		data: function () {
			return {
				adminDtls: JSON.parse(localStorage.getItem('adminDtls')),
				editItem: {},
				removeItem: {},
				action: null,
				removeBulkLoading: false,
				removeBulk: [],
				selectAllForRemoveBulk: false
			}
		},
		watch: {
			itemChanged: function () {
				this.editItem = {};
				this.action = null;
				this.removeItem = {};
			}
		},
		computed: {
			requestUserId(){
				return this.$store.getters.requestUserId;
			}
		},
		methods: {
			edit(redirect) {
				this.editItem = Object.assign({}, redirect);
			},
			update() {
				let error = false;
				let message = "Please fill all fields.";
				if (!this.editItem.from || !this.editItem.to || !this.editItem.code) {
					error = true;
				} else if(this.validateUrl(this.editItem.to) || this.validateUrl(this.editItem.from)){
					error = true;
					message = "You need fill correct redirect";
				}

				if (error) {
					swal({
						title: "All Fields are Required!",
						html: message,
						type: "error"
					});
					return false;
				}
                this.action = 'update';
				this.editItem.domain = this.domain;
				this.$emit('update', this.editItem);
			},
			remove(redirect) {
				this.removeItem = redirect;
				swal({
					title: "Are you sure?",
					text: `Are you sure you want to delete this redirect?`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.action = 'remove';
							this.$emit('remove', redirect);
						}
					});
			},
			cancel(){
				this.action = null;
				this.editItem = {};
			},
			handleSelectAllForRemoveBulk(){
				if(!this.selectAllForRemoveBulk) {
					this.removeBulk = this.redirects.map(redirect => {
						return redirect.uuid;
					});
				} else {
					this.removeBulk = []
				}
			},
			async removeBulkRedirects() {
				this.removeBulkLoading = true;
				try{
					const finalRedirects = this.redirects.filter(redirect => {
						const isFound = this.removeBulk.filter(redirectId => redirectId === redirect.uuid);
						if(isFound.length) {
							return false;
						}
						return redirect;
					});
					console.log(finalRedirects);
					const hostingAccountRef = await db.collection("hostingAccounts").doc(this.requestUserId).get();
					const { accounts } = hostingAccountRef.data();
					accounts.forEach(account => {
						if(account.primary.domain === this.domain) {
							account.primary.redirects = finalRedirects;
						}
						account.addon.forEach(item => {
							if(item.domain === this.domain) {
								item.redirects = finalRedirects;
							}
						})
					});
					await db.collection("hostingAccounts").doc(this.requestUserId).update({
						accounts: accounts
					});
					this.removeBulkLoading = false;
				}catch (e) {
					console.error(e);
					this.removeBulkLoading = false;
				}
			}
		}
	}
</script>


<style>
	.loader.small_loader {
		width: 15px;
		height: 15px;
	}
	.item-type{
		width: 75px;
	}
	.item-to{
		width: calc(100% - 75px);
	}
	.table th{
		font-weight: normal;
	}
</style>
